import { createContext, useContext } from 'react'

/** The account App has verified with /auth/me. Resource APIs still enforce authorization. */
const CurrentUserIdContext = createContext<string | null>(null)

export const CurrentUserIdProvider = CurrentUserIdContext.Provider
export const useCurrentUserId = () => useContext(CurrentUserIdContext)
